var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGdpr64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12L32.648 14.0971H34.7451L33.0486 15.3931L33.6965 17.4902L32 16.1933L30.3039 17.4902L30.9519 15.3931L29.2549 14.0971H31.352L32 12Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 46.5098L32.648 48.6075H34.7451L33.0486 49.9033L33.6965 52L32 50.7043L30.3039 52L30.9519 49.9033L29.2549 48.6075H31.352L32 46.5098Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6279 15.1372L41.2756 17.2343H43.373L41.6762 18.5308L42.3243 20.6274L40.6279 19.3309L38.9312 20.6274L39.5792 18.5308L37.8828 17.2343H39.9802L40.6279 15.1372Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6867 21.085L48.3344 23.1819H50.4316L48.7349 24.4783L49.383 26.5752L47.6867 25.2792L45.99 26.5752L46.6381 24.4783L44.9414 23.1819H47.0382L47.6867 21.085Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6868 37.8823L48.3344 39.9801H50.4316L48.735 41.276L49.3834 43.3725L47.6868 42.0771L45.99 43.3725L46.6381 41.276L44.9414 39.9801H47.0387L47.6868 37.8823Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3137 21.085L16.9614 23.1819H19.0586L17.362 24.4783L18.0098 26.5752L16.3137 25.2792L14.6168 26.5752L15.2649 24.4783L13.5684 23.1819H15.6659L16.3137 21.085Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.255 29.2549L49.9027 31.3518H52L50.3033 32.6477L50.9513 34.7451L49.255 33.4496L47.5584 34.7451L48.2068 32.6477L46.5098 31.3518H48.6066L49.255 29.2549Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7455 29.2549L15.3932 31.3518H17.4902L15.7934 32.6477L16.4419 34.7451L14.7455 33.4496L13.0486 34.7451L13.6968 32.6477L12 31.3518H14.0973L14.7455 29.2549Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3138 37.8823L16.9616 39.9801H19.0586L17.3622 41.276L18.0098 43.3725L16.3138 42.0771L14.6171 43.3725L15.2651 41.276L13.5684 39.9801H15.6658L16.3138 37.8823Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1964 44.9412L42.8441 47.0379H44.9414L43.2443 48.3346L43.8927 50.4314L42.1964 49.1355L40.4994 50.4314L41.1479 48.3346L39.4512 47.0379H41.5485L42.1964 44.9412Z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3731 15.1372L24.0207 17.2343H26.1181L24.4214 18.5308L25.0698 20.6274L23.3731 19.3309L21.6767 20.6274L22.3247 18.5308L20.6279 17.2343H22.7249L23.3731 15.1372Z",
    fill: "#FFFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8035 44.9412L22.4515 47.039H24.5488L22.8522 48.3345L23.5001 50.4314L21.8035 49.1363L20.1072 50.4314L20.7552 48.3345L19.0586 47.039H21.1554L21.8035 44.9412Z",
    fill: "#FFFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5821 29.6575L31.4152 35.9557C31.2376 36.1372 30.8867 36.2857 30.6354 36.2857H30.1027C29.8514 36.2857 29.5005 36.1367 29.3231 35.9557L26.419 32.9829C26.2416 32.8014 26.2418 32.5046 26.4197 32.3236L27.5626 31.159C27.7405 30.9775 28.0314 30.9775 28.2095 31.1585L30.0649 33.0451C30.243 33.2263 30.5339 33.2261 30.7115 33.0446L35.7968 27.8508C35.9744 27.6695 36.2655 27.6685 36.4438 27.849L37.5807 28.9994C37.7588 29.1802 37.7595 29.4758 37.5821 29.6575V29.6575Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGdpr64Px);
export default __webpack_public_path__ + "static/media/ic_gdpr-64px.fb5c6f1aae45667651ffa52c80d2c83b.svg";
export { ForwardRef as ReactComponent };